export const TRANSACTION_STATUS = {
    STATUS_PENDING: 'Pending',
    STATUS_IN_REVIEW: 'In Review',
    STATUS_PROCESSING: 'Processing',
    STATUS_SETTLED: 'Settled',
    STATUS_COMPLETED: 'Completed',
    STATUS_REJECTED: 'Rejected',
    STATUS_DELETED: 'Deleted',
    STATUS_APPROVED: 'Approved'
}

export const TRANSACTION_TYPE = {
    TYPE_CREDIT: 'Credit',
    TYPE_DEBIT: 'Debit',
    TYPE_SEPA_TRANSFER: 'sepa_transfer',
    TYPE_SWIFT_TRANSFER: 'swift_transfer',
    TYPE_SWIFT_FEE: 'swift_transfer_fee',
    TYPE_SEPA_FEE: 'sepa_transfer_fee',
    TYPE_INTERNAL: 'internal',
    TYPE_INTERNAL_DEBIT: 'internal_debit',
    TYPE_FX_TRANSFER: 'FX',
    TYPE_FX_FEE: 'fx_fee',
    TYPE_FX_SPREAD: 'fx_spread'
}


export const TRANSACTION_TYPE_LABELS = {
    credit: 'Credit',
    debit: 'Debit',
    sepa_transfer: 'SEPA Transfer',
    swift_transfer: 'SWIFT Transfer',
    swift_transfer_fee: 'SWIFT Fee',
    sepa_transfer_fee: 'SEPA Fee',
    internal: 'Internal Transfer',
    internal_debit: 'Internal Debit',
    FX: 'FX Transfer',
    fx_fee: 'FX Fee',
    fx_spread: 'FX Spread'
}